module.exports = __webpack_public_path__ + "img/icon-camera.503e846d.png";